import { Link, useLocation, useNavigate } from 'react-router-dom';
import './MainBottomTabs.css';
import { FaPlus } from 'react-icons/fa';
import { PiHandTapFill, PiHandTapLight, PiMapPinArea, PiMapPinAreaFill } from 'react-icons/pi';
import { BsPerson, BsPersonFill } from 'react-icons/bs';
import { GoHome, GoHomeFill } from 'react-icons/go';
import { useAuth } from '../../context';
import { useTranslation } from 'react-i18next';

function MainBottomTabs() {
  const { t } = useTranslation('bottom_tabs');
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn } = useAuth();

  const handleAddClick = () => {
    if(isLoggedIn) {
      navigate('/my_properties/create');
    } else {
      navigate('/login');
    }
  };

  const handleTabClick = (e, path) => {
    if (location.pathname === path) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="bottom-tab-bar d-md-none d-flex">
      <Link to="/" className={`tab-item ${location.pathname === '/' ? 'active' : ''}`} onClick={(e) => handleTabClick(e, '/')}>
        {location.pathname === '/' ?      
          <GoHomeFill size={22} />
        :
          <GoHome size={22} />
        }
        <span>{t('home')}</span>
      </Link>
      <Link to="/offices" className={`tab-item ${location.pathname === '/offices' ? 'active' : ''}`} onClick={(e) => handleTabClick(e, '/offices')}>
        {location.pathname === '/offices' ?
          <PiMapPinAreaFill size={22} />
        :
          <PiMapPinArea size={22} />
        }
        <span>{t('offices')}</span>
      </Link>

      <div className={`plus-button`} onClick={() => handleAddClick()}>
        <FaPlus size={22} />
      </div>

      <Link to="/profile" className={`tab-item ${location.pathname === '/profile' || location.pathname === '/login' ? 'active' : ''}`} onClick={(e) => handleTabClick(e, '/profile')}>
        {location.pathname === '/profile' || location.pathname === '/login' ?
          <BsPersonFill size={22} />
        :
          <BsPerson size={22} />
        }
        <span>{t('account')}</span>
      </Link>

      <Link to="/menu" className={`tab-item ${location.pathname === '/menu' ? 'active' : ''}`} onClick={(e) => handleTabClick(e, '/menu')}>
        {location.pathname === '/menu' ?
          <PiHandTapFill size={22} />
        :
          <PiHandTapLight size={22} />
        }
        <span>{t('menu')}</span>
      </Link>
    </div>
  );
}

export default MainBottomTabs;